import Icon from '../components/Icon.vue'

Icon.register({
  'bowling-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM120 192C102.3 192 88 177.7 88 160S102.3 128 120 128 152 142.3 152 160 137.7 192 120 192zM184 96C184 78.3 198.3 64 216 64S248 78.3 248 96 233.7 128 216 128 184 113.7 184 96zM232 240C214.3 240 200 225.7 200 208S214.3 176 232 176 264 190.3 264 208 249.7 240 232 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bowling-ball.js
// module id = 0x2Y
// module chunks = 144